import React from 'react';
import PropTypes from 'prop-types';
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import InputGroup, { InputGroupText } from 'components/ui/form/input_group';
import Label from 'components/ui/form/label';
import Input from 'components/ui/form/input';
import { FormFieldError } from 'components/ui/index';
import FormGroup from 'components/ui/form/form_group';
import Typeahead from 'components/ui/form/typeahead';

const FormTextInput = ({
  isRequired,
  disabled,
  label,
  input,
  type,
  placeholder,
  className,
  prepend,
  append,
  labelClassName = '',
  meta = {},
  formGroupProps = {},
  autocomplete,
  onInput,
  ...otherProps
}) => {
  const { rowProps, ...restProps } = otherProps;
  const finalInput = isEmpty(autocomplete) ? (
    <Input
      disabled={disabled}
      invalid={meta.touched && !!meta.error}
      type={type}
      placeholder={placeholder}
      {...input}
      {...restProps}
      onChange={(ev) => {
        input.onChange(ev);
        onInput && onInput(ev);
      }}
    />
  ) : (
    <Typeahead
      id={input.name}
      disabled={disabled}
      onChange={(selectedOptions) => {
        const options = selectedOptions.map((option) => {
          if (isString(option)) {
            return option;
          }
          if (isObject(option)) {
            return option.label;
          }
        });
        input.onChange(isArray(options) ? options[0] : options);
      }}
      selected={isString(input.value) ? [input.value] : input.value}
      allowNew={autocomplete.allowNew || true}
      clearButton={autocomplete.clearButton || true}
      options={autocomplete.options}
    />
  );

  const hasInputGroup = !!prepend || !!append;

  return (
    <FormGroup {...formGroupProps} className={className}>
      {label && (
        <Label className={labelClassName}>
          {label} {isRequired && <span style={{ color: 'red' }}> *</span>}
        </Label>
      )}
      {!hasInputGroup && (
        <>
          {finalInput}
          <FormFieldError meta={meta} />
        </>
      )}
      {hasInputGroup && (
        <InputGroup className="has-validation">
          {prepend && <InputGroupText>{prepend}</InputGroupText>}
          {finalInput}
          {append && <InputGroupText>{append}</InputGroupText>}
          <FormFieldError meta={meta} />
        </InputGroup>
      )}
    </FormGroup>
  );
};

FormTextInput.defaultProps = {
  label: null,
  type: 'text',
  placeholder: null,
  prepend: null,
  append: null,
  meta: {
    error: null,
    touched: false,
  },
};

FormTextInput.propTypes = {
  label: PropTypes.any,
  type: PropTypes.string,
  input: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  meta: PropTypes.object.isRequired,
  prepend: PropTypes.node,
  append: PropTypes.node,
};

export default FormTextInput;
